// Copyright (c) 2016 Deere & Company

import {
    createErrorObject,
    errorAlertBar
} from '../../../shared/services/alert-bar';
import {
    isLengthAtLeast,
    isLengthWithinRange
} from '../../../shared/services/validation-service';
import intersection from 'lodash.intersection';

const getKeyList = list => {

    const keyList = [];

    list.forEach(item => keyList.push(item.key));

    return keyList;

};

const filterItemOnDealers = (accountNumber, selectedDealers) => selectedDealers.some(item => item.account === accountNumber);

const filterItemOnStatuses = (statusList, selectedStatuses) => {

    const statusListKeys = getKeyList(statusList);
    const selectedStatusKeys = getKeyList(selectedStatuses);

    return selectedStatuses.length ?
    intersection(statusListKeys, selectedStatusKeys).length !== 0 :
        true;

};

const filterItemOnDateRange = (registrationDate, selectedDateRange) => selectedDateRange.from <= registrationDate && registrationDate <= selectedDateRange.to;

const validateClaim = queryString => {

    const claimMaxLength = 9;
    const claimMinLength = 4;

    return isLengthWithinRange(queryString, claimMaxLength, claimMinLength);

};

const validatePip = queryString => {

    const pipMaxLength = 12;
    const pipMinLength = 4;

    return isLengthWithinRange(queryString, pipMaxLength, pipMinLength);

};

const validateModel = queryString => {

    const modelMaxLength = 12;
    const modelMinLength = 3;

    return isLengthWithinRange(queryString, modelMaxLength, modelMinLength);

};

const validateComponent = queryString => {

    const componentMinLength = 1;

    return isLengthAtLeast(queryString, componentMinLength);

};

const validatePin = queryString => {

    const pinMaxLength = 17;
    const pinMinLength = 6;

    return isLengthWithinRange(queryString, pinMaxLength, pinMinLength);

};

export const getSortOptions = () => [
    {
        displayName: 'DEALER_LOCATION',
        path: [
            'dealer',
            'account'
        ]
    },
    {
        displayName: 'DELIVERED',
        path: [
            'deliveryDate'
        ]
    },
    {
        displayName: 'AMOUNT_OF_USE',
        path: [
            'useAmount',
            'amount'
        ]
    },
    {
        displayName: 'MODEL',
        path: [
            'model'
        ]
    },
    {
        displayName: 'UPDATED',
        path: [
            'updatedDate'
        ]
    },
    {
        displayName: 'REGISTERED',
        path: [
            'registrationDate'
        ]
    }
];

export const getFilterOptions = () => [
    ['pin'],
    [
        'customerSummary',
        'displayName'
    ],
    [
        'dealer',
        'account'
    ],
    [
        'useAmount',
        'amount'
    ],
    [
        'model'
    ],
    [
        'baseMachineCode'
    ]
];

export const isLink = statusList => {

    const statusKeyList = getKeyList(statusList);

    return intersection(statusKeyList, ['EOOS']).length === 0;

};

export const mapProductValidation = (key, queryString) => {

    const map = {
        CLAIM: validateClaim,
        COMPONENT: validateComponent,
        MODEL: validateModel,
        PIN: validatePin,
        PIP: validatePip
    };

    return map[key](queryString);

};

export const mapSearchPlaceHolder = key => {

    const map = {
        CLAIM: 'SEARCH_PRODUCT_BY_CLAIM_PLACEHOLDER',
        COMPONENT: 'SEARCH_PRODUCT_BY_COMPONENT_PLACEHOLDER',
        MODEL: 'SEARCH_PRODUCT_BY_MODEL_PLACEHOLDER',
        PIN: 'SEARCH_PRODUCT_BY_PIN_PLACEHOLDER',
        PIP: 'SEARCH_PRODUCT_BY_PIP_PLACEHOLDER'
    };

    return map[key];

};

export const mapValidationErrorMessages = key => {

    const map = {
        CLAIM: 'SEARCH_PRODUCT_BY_CLAIM_VALIDATION_FAIL',
        COMPONENT: 'SEARCH_PRODUCT_BY_COMPONENT_VALIDATION_FAIL',
        MODEL: 'SEARCH_PRODUCT_BY_MODEL_VALIDATION_FAIL',
        PIN: 'SEARCH_PRODUCT_BY_PIN_VALIDATION_FAIL',
        PIP: 'SEARCH_PRODUCT_BY_PIP_VALIDATION_FAIL'
    };

    return map[key];

};

const filterOnDateRange = (registrationDate, dateRange) => dateRange.from && dateRange.to ?
    filterItemOnDateRange(registrationDate, dateRange) :
    true;

export const filterSearchResults = (searchResults, selectedDealers, selectedStatuses, selectedDateRange) =>
    searchResults.filter(item =>
        filterItemOnDealers(item.dealer.account, selectedDealers) &&
        filterItemOnStatuses(item.status, selectedStatuses) &&
        filterOnDateRange(item.registrationDate, selectedDateRange)
    );

export const showValidationError = (formatMessage, key) => errorAlertBar(createErrorObject(formatMessage({id: key})));



// WEBPACK FOOTER //
// ./src/product/shared/services/product-search-helper.js